import { GAEvent } from './events';
import { createUndefinedObject, pushDataLayer } from './utils';

interface MeditationData {
  meditation_id: string | number;
  meditation_name: string;
}

export const trackMeditation = async (data: MeditationData) => {
  pushDataLayer<MeditationData>(GAEvent.MEDITATION_COMPLETED, data);
};

export const clearMeditationDataLayer = () => {
  const data = createUndefinedObject<MeditationData>();
  pushDataLayer(`clear_${GAEvent.MEDITATION_COMPLETED}`, data);
};
